import commonApi from './CommonApi.js';

var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/admin/users/getAll', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/admin/users/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	create: async (viewModel) => {
		return await commonApi().post('/v1/admin/users', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/admin/users', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/admin/users', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	countryHasEPingAdmin: async (parameters) => {
		return await commonApi().get('/v1/users/countryHasEPingAdmin', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getProfile: async (parameters) => {
		return await commonApi().get('/v1/users/getProfile', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	checkUser: async (parameters) => {
		return await commonApi().get('/v1/users/checkUser', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	editProfile: async (viewModel) => {
		return await commonApi().put('/v1/users/editProfile', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	tourSharedNotification: async () => {
		return await commonApi().post('/v1/users/tourSharedNotification', {})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getNationalEPingUsers: async (parameters) => {
		return await commonApi().get('/v1/users/getNationalEPingUsers', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	exportToExcelList: async (parameters) => {
		return await commonApi().get('/v1/users/exportToExcelList',
			//{ params: parameters, responseType: 'blob' }
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				var fileName = 'Users.xlsx';
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	nationalEPingUsersExportToExcel: async (parameters) => {
		return await commonApi().get('/v1/users/nationalEPingUsersExportToExcel',
			//{ params: parameters, responseType: 'blob' }
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				var fileName = 'NationalEPingUsers.xlsx';
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	userRights: async (parameters) => {
		return await commonApi().get('/v1/users/userRights', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	saveUserRights: async (viewModel) => {
		return await commonApi().post('/v1/users/userRights', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}